import { put, call, fork, takeMaybe } from 'redux-saga/effects'
import { collectionListService } from 'src/api/collection'
import { getCollectionListSuccess } from 'src/reducers/collection/action'
import { COLLECTION_LIST_GET } from 'src/reducers/collection/type'
import generalSaga from '../general'
import { operationSuccess, operationFail } from 'src/reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* collectionListFlow(payload) {
  try {
    const { query, callback } = payload
    const response = yield call(collectionListService, query)

    yield put(getCollectionListSuccess(response.data))
    yield put(operationSuccess())

    callback(response.data)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* collectionListWatcher() {
  while (true) {
    const action = yield takeMaybe(COLLECTION_LIST_GET)
    const { payload } = action

    yield fork(generalSaga, collectionListFlow, payload)
  }
}
